import { IScale } from "@/modules/assessments/types/scale.interface";
import { ITest } from "@/modules/assessments/types/test.interface";

import { httpClient } from "@/shared/services/http";

export class TestHttpService {
  static async getAllTestsAsAdmin() {
    const { data: tests } = await httpClient.get(`/api/tests`);

    return tests;
  }

  static async getTestsStats() {
    const { data: tests } = await httpClient.get(`/api/tests?stats=true`);

    return tests;
  }

  static async getTestById(testId: number): Promise<ITest> {
    const { data: test } = await httpClient.get(`/api/tests/${testId}`);

    return test;
  }

  static async getSpecificTestScales(testId: number): Promise<IScale[]> {
    const { data: scales } = await httpClient.get(`/api/tests/${testId}/scales`);
    return scales;
  }

  static async getAllClientTests(clientId: number, options: { standaloneOnly?: boolean; assessmentId?: number } = {}) {
    const { standaloneOnly = false, assessmentId } = options;
    const params: Record<string, unknown> = {};
    if (standaloneOnly) {
      params.standalone = true;
    }
    // When scoped to an assessment, the API returns only tests offered in all of its enabled locales.
    if (assessmentId) {
      params.assessmentId = assessmentId;
    }
    const { data: tests } = await httpClient.get(`/api/clients/${clientId}/tests`, { params });

    return tests;
  }

  static async addTestToAssessment(clientId: string, assessmentId: string, testId: string, postData: { rank: number }) {
    const { data: addedTest } = await httpClient.post(
      `/api/clients/${clientId}/assessments/${assessmentId}/tests/${testId}`,
      postData,
    );
    return addedTest;
  }

  static async updateTestInAssessment(
    clientId: string,
    assessmentId: string,
    testId: string,
    postData: { rank?: number; normId?: number },
  ) {
    return httpClient.patch(`/api/clients/${clientId}/assessments/${assessmentId}/tests/${testId}`, postData);
  }

  static async deleteTestFromAssessmentById(clientId: string, assessmentId: string, testId: string) {
    const { data: removedTest } = await httpClient.delete(
      `/api/clients/${clientId}/assessments/${assessmentId}/tests/${testId}`,
    );
    return removedTest;
  }

  static async getTestScales(clientId: string, testId: number): Promise<IScale[]> {
    const { data: scales } = await httpClient.get(`/api/clients/${clientId}/tests/${testId}/scales`);
    return scales;
  }
}
